<template>
	<section class="message-register">
		<form @submit.prevent="register">
			<ManagingSection>
				<ManagingBox title="내용">
					<textarea
						class="message-register__textarea"
						v-model="message"
					></textarea>
				</ManagingBox>
				<ManagingBox title="대상">
					<RadioList
						:radioList="targetOptions"
						:value="target"
						@input="changeValue"
					/>
				</ManagingBox>
				<ManagingBox title="업데이트 구분">
					<RadioList
						:radioList="updateOptions"
						:value="update"
						@input="changeUpdate"
					/>
				</ManagingBox>
				<ManagingBox title="IOS 신규버전">
					<input
						type="text"
						v-model="iosVersion"
						placeholder="IOS 버전을 입력하세요"
					/>
				</ManagingBox>
				<ManagingBox title="Android 신규버전">
					<input
						type="text"
						v-model="androidVersion"
						placeholder="Android 버전을 입력하세요"
					/>
				</ManagingBox>
				<ManagingBox title="OS 선택">
					<CheckboxList v-model="osList" :checkboxList="osOptions" />
				</ManagingBox>
				<div class="btn-wrap-main message-register__button-wrap">
					<button type="submit" class="btn-main blue">등록</button>
					<button type="button" class="btn-main" @click="init">
						초기화
					</button>
				</div>
			</ManagingSection>
		</form>
	</section>
</template>
<script>
	import ManagingSection from '../../components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '../../components/RadioList.vue';
	import CheckboxList from '../../components/CheckboxList.vue';

	export default {
		components: {
			ManagingSection,
			ManagingBox,
			CheckboxList,
			RadioList,
		},
		data() {
			return {
				message: '',
				target: null,
				os: '',
				osList: [],
				iosVersion: '',
				androidVersion: '',
				targetOptions: [
					{ id: '1', value: '일반' },
					{ id: '2', value: '업데이트' },
					{ id: '3', value: '일반-강제종료' },
				],
				update: null,
				updateOptions: [
					{ id: '1', value: '강제 스토어로 이동' },
					{ id: '2', value: '확인만 표시' },
					{ id: '3', value: '업데이트 여부 선택' },
				],
				osOptions: [
					{ id: '2', value: 'IOS' },
					{ id: '1', value: 'Android' },
				],
			};
		},
		watch: {
			osList: {
				handler: function (os) {
					this.updateOs(os);
				},
				deep: true,
			},
		},
		methods: {
			changeValue(type) {
				this.target = type;
			},
			changeUpdate(type) {
				this.update = type;
			},
			async register() {
				const params = {
					messageText: this.message,
					messageType: this.target,
					osSelect: this.os,
					iosVersion: this.iosVersion,
					androidVersion: this.androidVersion,
					messageState: '0',
					updateType: this.update,
				};
				if (!this.validation()) return;

				try {
					await this.$axiosAdmin2.post(
						'/api/operation/app-message',
						params
					);
					alert('메시지가 등록되었습니다.');
					this.init();
					this.$router.push('/operation/message');
				} catch (error) {
					console.error(error);
					alert(
						'메시지 등록에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의주세요'
					);
				}
			},
			validation() {
				if (this.message === '') {
					alert('내용을 입력해주세요');
					return false;
				}
				if (this.target === null) {
					alert('대상을 선택해주세요');
					return false;
				}
				if (this.update === null) {
					alert('업데이트 구분을 선택해주세요');
					return false;
				}
				if (!this.os) {
					alert('OS를 선택해주세요');
					return false;
				}
				if (
					(this.os === '2' || this.os === '0') &&
					this.iosVersion === ''
				) {
					alert('IOS 버전을 입력해주세요');
					return false;
				}
				if (
					(this.os === '1' || this.os === '0') &&
					this.androidVersion === ''
				) {
					alert('Android 버전을 입력해주세요');
					return false;
				}
				return true;
			},
			init() {
				this.message = '';
				this.target = null;
				this.os = '';
				this.iosVersion = '';
				this.androidVersion = '';
				this.update = null;
				this.osList = [];
			},
			updateOs(os) {
				if (os.length === 2) {
					this.os = '0';
				} else {
					this.os = os[0];
				}
			},
		},
	};
</script>
<style lang="scss" scoped></style>
